import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/step-tick-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-f1f37d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-start ps-0"
}
const _hoisted_2 = { class: "nav-item row" }
const _hoisted_3 = { class: "col-icon d-flex" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "col-link d-inline-block ps-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.items.length > 0)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass(["mb-2 mt-3", {'mb-3': index != _ctx.items.length - 1}])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (item.isChecked)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!_ctx.isClickable(item, _ctx.items[index - 1] ?? null))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["item-content item-placeholder-gray", { active: _ctx.isActive(_ctx.activeItem, item) }])
                    }, _toDisplayString(item.text), 3))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: item.link,
                      class: _normalizeClass(["text-decoration-none item-content item-placeholder-gray", { active: _ctx.isActive(_ctx.activeItem, item) }])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
              ])
            ])
          ], 2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}